import { render, staticRenderFns } from "./NewReportStatistic.vue?vue&type=template&id=02998a4c&scoped=true"
import script from "./NewReportStatistic.vue?vue&type=script&lang=js"
export * from "./NewReportStatistic.vue?vue&type=script&lang=js"
import style0 from "./NewReportStatistic.vue?vue&type=style&index=0&id=02998a4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02998a4c",
  null
  
)

export default component.exports